import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import propertyConvoSummaryService from '../services/property-convo-summary.service';

export function getPropertyConvoSummariesQueryKey(propertyId: string) {
  return ['property', propertyId, 'convo-summaries'];
}

export function usePropertyConvoSummariesQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => getPropertyConvoSummariesQueryKey(propertyId.value),
    query: () => propertyConvoSummaryService.getConvoSummaries(propertyId.value),
  });
}
